import React from 'react'
import _ from 'lodash'
import {
  COLUMN_TYPES,
  Icon,
  Popup,
  constants,
  coreConstants,
} from '@adc/ui-morpheus'
import { ADD_FORM_VENUE_TEMPLATES_FILTER } from '../../constants/actionTypes'
const { states: statesList } = coreConstants.optionLists
const {
  actionCellActionTypes: { ACTION_CELL_ACTION_TYPES },
} = constants

const defaultColPropsWithWidth150 = {
  width: 150,
  isResizable: true,
  isReorderable: true,
  isVisible: true,
}
const defaultColPropsWithWidth75 = {
  width: 75,
  isResizable: true,
  isReorderable: true,
  isVisible: true,
}
export const tableConfig = {
  fieldDefinitions: [
    {
      name: 'Template Name',
      apiRef: 'template_name',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth150,
      },
    },
    {
      name: 'Venue Name',
      apiRef: 'venue_name',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth150,
      },
    },
    {
      name: 'Address',
      apiRef: 'full_address',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: { ...defaultColPropsWithWidth150, width: 300 },
      },
    },
    {
      name: 'Venues',
      apiRef: 'venues',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth75,
      },
    },
    {
      name: 'Schedules',
      apiRef: 'schedules',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth150,
      },
    },
    {
      name: 'Type',
      apiRef: 'venue_configuration.venue_type',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth75,
      },
    },
    {
      name: 'Trustee',
      apiRef: 'trustee',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth75,
      },
    },
    {
      name: 'State',
      apiRef: 'venue_address.country_primary_subdivision',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColPropsWithWidth75,
      },
    },
    {
      name: '',
      apiRef: '__actions__',
      columnDefinition: {
        actions: [ACTION_CELL_ACTION_TYPES.REMOVE_ROW],
        type: COLUMN_TYPES.ACTION,
        colProps: { width: 40, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Popup
        content='Remove Template'
        key={actionIndex}
        size='tiny'
        trigger={
          <Icon
            link
            color='error'
            size='large'
            name='delete'
            onClick={() => {
              onRowAction(actionCellActionType, rowIndex, primaryId)
            }}
            style={{ marginTop: -3 }}
            data-elm-id={`action_remove_${rowIndex}`}
          />
        }
      />
    )

const getFetchVenueTemplatesOptions = searchValue => {
  const filterBy = [
    {
      fields: ['template_status'],
      values: ['ACTIVE'],
    },
  ]
  const stateFound = _.find(statesList, state => {
    return (
      state.value === _.trim(_.toUpper(searchValue)) ||
      state.text === _.startCase(_.toLower(searchValue))
    )
  })

  const states = stateFound ? [stateFound.value] : []
  if (!_.isEmpty(states)) {
    filterBy.push({
      fields: ['venue_address.country_primary_subdivision'],
      values: states,
    })
  } else {
    filterBy.push({
      fields: ['template_name', 'venue_address.country_secondary_subdivision'],
      values: [searchValue],
    })
  }
  return filterBy
}

/**
 *
 * @param {*} fieldDefinitions
 * THIS SELECTOR IS TO MAINTAIN BACKWARDS COMPATIBILITY WITH EVERYTHING IN TOOLKIT
 * It will change/ be removed when everything there changes. This is so we can refactor slowly
 */
const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      if (col.dataType) column.dataType = col.dataType
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      return column
    })

export default (state = tableConfig, action) => {
  switch (action.type) {
    case ADD_FORM_VENUE_TEMPLATES_FILTER:
      return {
        ...state,
        filterClauses: getFetchVenueTemplatesOptions(action.searchValue),
      }
  }
  return state
}

export { columnSelector }
